import { render } from "./azioniMacchine.vue?vue&type=template&id=3926b9c0&ts=true"
import script from "./azioniMacchine.vue?vue&type=script&lang=ts"
export * from "./azioniMacchine.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/AreaClienti_SELENIA/AreaClienti_SELENIA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__